var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcVideoBannerPause = function SvgIcVideoBannerPause(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1283_55087)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1283_55087",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 19,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 19,
    rx: 1,
    stroke: "white",
    strokeWidth: 5.5,
    mask: "url(#path-1-inside-1_1283_55087)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_1283_55087",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 8,
    height: 19,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 8,
    height: 19,
    rx: 1,
    stroke: "white",
    strokeWidth: 5.5,
    mask: "url(#path-2-inside-2_1283_55087)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1283_55087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVideoBannerPause, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_video_banner_pause.fe064df0.svg";
export { ForwardRef as ReactComponent };